export const getAdminUserInitials = (adminUser: any) => {
  const initials = adminUser
    ? (adminUser?.firstName[0] as unknown as string) +
      (adminUser?.lastName[0] as unknown as string)
    : null;
  return initials;
};
